// Functional baseline captured right after onboarding.
// Values are 1–4 (1 = best / most independent, 4 = most support needed).

export const BASELINE = {
  mobility: {
    key: 'baseline_mobility',
    label: 'Mobility',
    question: (name) => `How is ${name} getting around day to day?`,
    options: [
      { icon: '🚶', label: 'Fully independent', sub: 'moves around without help' },
      { icon: '🦯', label: 'Mostly independent', sub: 'manages but slowly or carefully' },
      { icon: '🤝', label: 'Needs some support', sub: 'help with stairs, outdoor walking' },
      { icon: '🛋️', label: 'Significant help needed', sub: 'support for most movement' },
    ],
  },
  memory: {
    key: 'baseline_memory',
    label: 'Memory',
    question: (name) => `How is ${name}'s memory and thinking?`,
    options: [
      { icon: '🧠', label: 'Sharp', sub: 'no real concerns' },
      { icon: '📝', label: 'Some forgetfulness', sub: 'normal senior moments' },
      { icon: '😕', label: 'Noticeable gaps', sub: 'repeating questions, forgetting appointments' },
      { icon: '⚠️', label: 'Significant concerns', sub: 'confusion, disorientation' },
    ],
  },
  mood: {
    key: 'baseline_mood',
    label: 'Mood',
    question: (name) => `How would you describe ${name}'s general mood lately?`,
    options: [
      { icon: '😊', label: 'Generally positive and engaged' },
      { icon: '😐', label: 'Some low days but mostly okay' },
      { icon: '😔', label: 'More withdrawn or low than usual' },
      { icon: '😟', label: 'Significant concerns', sub: 'persistent sadness or anxiety' },
    ],
  },
  independence: {
    key: 'baseline_independence',
    label: 'Independence',
    question: (name) => `How is ${name} managing daily tasks at home?`,
    options: [
      { icon: '✅', label: 'Fully independent', sub: 'cooking, cleaning, medications all managed' },
      { icon: '🔄', label: 'Mostly managing', sub: 'some tasks need reminders or help' },
      { icon: '🆘', label: 'Needs regular help', sub: 'family or caregiver support several times a week' },
      { icon: '🏠', label: 'Significant support needed', sub: 'help required daily' },
    ],
  },
}

export const BASELINE_ORDER = ['mobility', 'memory', 'mood', 'independence']

// value: 1–4 → "🚶 Fully independent" (null if unset)
export function baselineLabel(domainKey, value) {
  if (value == null) return null
  const o = BASELINE[domainKey]?.options[value - 1]
  return o ? `${o.icon} ${o.label}` : null
}
